<template>
  <CContainer fluid>
    <h3>Entregas de Mercanc&iacute;a</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar: " 
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  class="text-dark"
                  @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#"
                  @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-2">
            <CSelect 
              label="Estado:" 
              addLabelClasses="text-muted font-weight-bold" 
              :options="wareDeliveryStatus"
              @update:value="value => {
                selectedWareDeliveryStatus = value
                getData(1)
              }"
            />
          </CCol>
        </CRow>
        <CDataTable
          hover
          :items="bills"
          :fields="fields"
          :items-per-page="itemsPerPage">
          <template #numero="{item}">
            <td>
              <h4>{{item.numero}}</h4>
              <span>{{item.prefijo}}</span>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <span><CIcon name="cil-building" class="mr-2"/>{{ item.empresa }}</span>
              </div>
              <div>
                <span><i class="bi bi-postcard mr-2"></i>{{ item.identificacion }}</span>
              </div>
            </td>
          </template>
          <template #fecha_Emision="{item}">
            <td>
              <div>
                <span><CIcon name="cil-calendar" class="mr-2"/>{{ moment(item.fecha_Emision).format('DD/MM/YYYY') }}</span>
              </div>
              <div>
                <span><i class="bi bi-person-workspace mr-2"></i>{{ item.empleado }}</span>
              </div>
            </td>
          </template>
          <template #valor_Total="{item}">
            <td>
              <div>
                <CBadge :color="getBadgeColor(item)" class="text-white">{{ deliveryStatus[item.estado_EntregaMercancia] }}</CBadge>
              </div>
              <div>
                <span>${{formatter.format(item.valor_Total, 0)}}</span>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#"
                class="mb-2 p-2"
                style="text-decoration: none;"
                @click="toggleDocument($event, item)">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end mb-3">
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Movimiento de factura'"
                  @click="openPanelKardex($event, item.id_Documento)">
                  <i class="bi bi-journal-text text-info h4"></i>
                </a>
                <a href="#"
                  class="mr-3"
                  v-c-tooltip="'Seriales'"
                  @click="openModalSeriales($event, item.id_Documento)">
                  <i class="bi bi-upc-scan text-dark h4"></i>
                </a>
              </div>
              <CCol sm="6" class="d-inline-block" style="vertical-align: top;">
                <div class="ml-4"><strong>Comentarios: </strong></div>
                <div class="ml-4"><strong></strong>{{item.comentario_01}}</div>
                <div class="ml-4"><strong></strong>{{item.comentario_02}}</div>
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          :activePage.sync="page"
          :pages="pageCount"
          size="sm"
          align="center"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />
      </CCardBody>

      <CElementCover  v-show="loading"/>
    </CCard>

    <right-side-bar size="lg" :show="showPanelKardex" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <h4 class="mt-1">Productos del Documento</h4>
          </CCardHeader>
          <CCardBody>
            <div class="panel-scroll">
              <document-kardex :id-document="idDocumento" :key="updateComponent" />
            </div>
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary"
            @click="showPanelKardex=false">
            <span class="align-middle">Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </right-side-bar>

    <right-side-bar :size="'lg'" :show="showModalSeriales" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <h4 class="mt-1">Seriales de Productos</h4>
          </CCardHeader>
          <CCardBody>
            <product-serials-document :idDocument="idDocumento" :key="updateComponent" />
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary"
            @click="showModalSeriales=false">
            <span class="align-middle">Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </right-side-bar>
  </CContainer>
</template>
<style>
  .panel-scroll {
    overflow-y: scroll;
    height: 57vh;
    max-height: 100vh;
  }
</style>
<script>
  import moment from "moment"
  import { formatter } from "../../general"
  import { dataGridDocumentos } from "../../api"
  import RightSideBar from "../containers/RightSideBar.vue"
  import DocumentKardex from "../datagrids/DocumentKardex.vue"
  import ProductSerialsDocument from "../datagrids/ProductSerialsDocument.vue"

  const fields = [
    {
      key: 'numero', 
      label: 'Documento',
      _style:'text-align:center;'
    },
    {
      key: 'empresa', 
      label: 'Empresa',
      _style:'text-align:center;'
    },
    {
      key: 'fecha_Emision', 
      label: 'Fechas',
      _style:'text-align:center;'
    },
    {
      key: 'valor_Total', 
      label: 'Estado',
      _style:'text-align:center;'
    },
    {
      key: 'info',
      label: ''
    }
  ]

  export default {
    data() {
      return {
        formatter,
        loading: false,
        showModalSeriales: null,
        showPanelKardex: null,
        updateComponent: 0,
        searchWord: "",
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        fields,
        bills: [],
        deliveryStatus: {
          "P": "Pendiente",
          "F": "Facturado"
        },
        selectedWareDeliveryStatus: "T",
        wareDeliveryStatus: [
          {
            label: "Todas",
            value: "T"
          },
          {
            label: "Pendientes",
            value: "P"
          },
          {
            label: "Facturadas",
            value: "F"
          }
        ],
        idDocumento: ""
      }
    },
    components: {
      RightSideBar,
      DocumentKardex,
      ProductSerialsDocument
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true

        console.log(this.selectedWareDeliveryStatus);

        this.searchWord = search
        if (page !== this.page) {
          this.page = page
        }

        try {
          const { count, results } = await dataGridDocumentos(
            this,
            this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null,
            null,
            page,
            search,
            "EntregasMercancia",
            this.selectedWareDeliveryStatus
          )

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          } 
          this.bills = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally{
          this.loading = false
        }        
      },
      openPanelKardex(e, idDocument) {
        e.stopPropagation()

        this.showPanelKardex = true
        this.idDocumento = idDocument
        this.updateComponent += 1
      },
      openModalSeriales(e, idDocument) {
        e.stopPropagation

        this.showModalSeriales = true
        this.idDocumento = idDocument
        this.updateComponent += 1

        console.log(idDocument);
      },
      toggleDocument(e, item){
        e.stopPropagation()

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getBadgeColor(item) {
        if(item.estado_EntregaMercancia === 'P') return 'danger'
        if(item.estado_EntregaMercancia === 'F') return 'success'
      }
    },
    mounted() {
      this.getData(this.page)    
    }
  }
</script>